var _path, _path2, _path3, _path4, _path5, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFcCarLoan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 19,
    viewBox: "0 0 37 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6472 1L26.5056 7.07296H6.46484L9.50132 1H21.6472Z",
    fill: "#795AF7",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0086 8.8933V14.359H1V8.8933L6.46567 7.67871H27.1137L35.0086 8.8933Z",
    fill: "#E8E8FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0086 14.3605H18.6116H3C1.89543 14.3605 1 13.4651 1 12.3605V10.3875C1 9.4551 1.64426 8.64642 2.55306 8.43806L4.9807 7.88148C5.53883 7.75352 6.01535 7.39246 6.28955 6.88976L8.93362 2.0423C9.28409 1.39977 9.95752 1 10.6894 1H20.7003C21.3002 1 21.8684 1.26925 22.2482 1.73353L26.6189 7.07551C26.9371 7.46436 27.3899 7.71923 27.8874 7.78942L33.288 8.55137C34.2748 8.69061 35.0086 9.53514 35.0086 10.5318V12.3605C35.0086 13.4651 34.1132 14.3605 33.0086 14.3605Z",
    stroke: "#080333",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85938 7.67773L27.3594 7.67773",
    stroke: "#080333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5742 1.60596V7.67892",
    stroke: "#080333",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.48241,
    cy: 15.2597,
    r: 2.72069,
    fill: "#795AF7",
    stroke: "#080333",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5254,
    cy: 15.2597,
    r: 2.72069,
    fill: "#795AF7",
    stroke: "#080333",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFcCarLoan);
export default __webpack_public_path__ + "static/media/fc-car-loan.8e6d5b71cfe05e86af37576b8e4d9a60.svg";
export { ForwardRef as ReactComponent };